import React from 'react';
import AccountSettings from '../../containers/AccountSettings/AccountSettings';

export class AccountSettingsPage extends React.Component {
  render() {
    return (
      <AccountSettings />
    );
  }
}